export const PIXO_ENVIRONMENT_OPTIONS = [
  {
    value: 'na-production',
    label: 'NA — Production',
    host: 'https://modules.apex.pixovr.com',
    platformHost: 'https://apex.pixovr.com',
  },
  {
    value: 'na-stage',
    label: 'NA — Stage',
    host: 'https://modules.apex.stage.pixovr.com',
    platformHost: 'https://apex.stage.pixovr.com',
  },
  {
    value: 'na-dev',
    label: 'NA — Dev',
    host: 'https://modules.apex.dev.pixovr.com',
    platformHost: 'https://apex.dev.pixovr.com',
  },
  {
    value: 'sa-production',
    label: 'SA — Production',
    host: 'https://saudi.modules.apex.pixovr.com',
    platformHost: 'https://saudi.apex.pixovr.com',
  },
];
